// 根据赛段开始和结束记录决定下一步；四节赛沿用与一至三节相同的顺序规则。
export function getNextCourseAction(totalCourse, events = []) {
    const total = Number(totalCourse)
    if (!Number.isInteger(total) || total < 1 || total > 4) return 'invalid'

    const started = events.filter(event => String(event?.eventId) === '8').length
    const ended = events.filter(event => String(event?.eventId) === '7').length

    if (started === 0 && ended === 0) return 'start'
    if (started === total && ended === total - 1) return 'finish'
    if (started === ended && started < total) return 'start'
    if (started === ended + 1 && started < total) return 'end'
    return 'invalid'
}
